import { createSlice } from '@reduxjs/toolkit';

import resetStore from '../resetStore';

const initialState = {
  activePopup: null,
  popupProps: {},
};

const popupSlice = createSlice({
  name: 'popup',
  initialState,
  reducers: {
    openPopup: (state, action) => {
      if (typeof action.payload === 'string') {
        state.activePopup = action.payload;
        state.popupProps = {};
      } else {
        state.activePopup = action.payload.name;
        state.popupProps = action.payload.props || {};
      }
    },
    closePopup: (state) => {
      state.activePopup = null;
      state.popupProps = {};
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetStore, () => initialState);
  },
});

export const { openPopup, closePopup } = popupSlice.actions;

export default popupSlice.reducer;
